import { useState, useEffect, useMemo } from "react";
import "./ResultadoBusca.css";
import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";
import VerificaToken from "../../components/utils/VerificaToken";
import { useNavigate, useParams } from "react-router-dom";

export default function ResultadoBusca() {
  const [ordenacao, setOrdenacao] = useState("alfabetica");

  const [menuOpen, setMenuOpen] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { dados } = useParams();
  const [usuario, setUsuario] = useState({
    login: false,
    codcliente: null,
    tipo: "",
  });

  useEffect(() => {
    async function verificar() {
      const dados = await VerificaToken();
      setUsuario(dados);
    }

    verificar();
  }, []);

  const ehCNPJ = usuario.login && usuario.tipo === "CNPJ";

  // Função para buscar os produtos
  const fetchProdutos = async () => {
    setLoading(true);

    try {

      const body = {
        busca: dados.replace(/_/g, " "),
      };

      if (ehCNPJ) {
        body.codcliente = usuario.codcliente;
      }


      const res = await fetch(
        "https://app.eliandroalimentos.com.br/api/busca/listar",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      const produtosData =
        await res.json();



      setProdutos(
        produtosData
      );
    } catch (err) {
      console.error(
        "Erro ao buscar produtos:",
        err
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
    fetchProdutos();
  }, [
    dados,
    ehCNPJ,
    usuario.codcliente,
  ]);

  const produtosOrdenados = useMemo(() => {
    const lista = [...produtos];

    switch (ordenacao) {
      case "menor-preco":
        lista.sort((a, b) => {
          const precoA =
            ehCNPJ && a.valorunitario != null
              ? Number(a.valorunitario)
              : Number(a.precovenda);

          const precoB =
            ehCNPJ && b.valorunitario != null
              ? Number(b.valorunitario)
              : Number(b.precovenda);

          return precoA - precoB;
        });
        break;

      case "maior-preco":
        lista.sort((a, b) => {
          const precoA =
            ehCNPJ && a.valorunitario != null
              ? Number(a.valorunitario)
              : Number(a.precovenda);

          const precoB =
            ehCNPJ && b.valorunitario != null
              ? Number(b.valorunitario)
              : Number(b.precovenda);

          return precoB - precoA;
        });
        break;

      default:
        lista.sort((a, b) =>
          a.Descricao.localeCompare(
            b.Descricao,
            "pt-BR",
            { sensitivity: "base" }
          )
        );
    }

    return lista;
  }, [produtos, ordenacao, ehCNPJ]);


  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
      />

      <div className="resultadobusca-wrapper">

        {/* TOPO */}
        <div className="resultadobusca-topo">

          <div>
            <h2>
              Resultados para "{dados.replace(/_/g, " ")}"
            </h2>

            <span>
              {loading
                ? "Carregando..."
                : `${produtos.length} produtos encontrados`}
            </span>
          </div>

          <div className="resultadobusca-acoes">

            <div>Ordenar por:</div>

            <select
              className="resultadobusca-ordenar-select"
              value={ordenacao}
              onChange={(e) => setOrdenacao(e.target.value)}
            >
              <option value="alfabetica">
                Ordem alfabética
              </option>

              <option value="menor-preco">
                Menor preço
              </option>

              <option value="maior-preco">
                Maior preço
              </option>
            </select>

          </div>

        </div>

        {/* PRODUTOS */}

        <section className="resultadobusca-produtos">

          {loading ? (

            <div className="resultadobusca-loading">
              Carregando produtos...
            </div>

          ) : produtos.length === 0 ? (

            <div className="resultadobusca-loading">
              Nenhum produto encontrado
            </div>

          ) : (

            produtosOrdenados.map((produto) => (

              <div
                className="resultadobusca-card"
                key={produto.CodItem}
              >

                <div className="resultadobusca-imagem-container">

                  {produto.foto ? (

                    <img
                      className="resultadobusca-imagem"
                      src={produto.foto}
                      alt={produto.descricao}
                    />

                  ) : (

                    <div className="resultadobusca-sem-imagem">
                      Sem imagem
                    </div>

                  )}

                </div>

                <div className="resultadobusca-meta">
                  {produto.quantemb} Kg - Cód. {produto.CodItem}
                </div>

                <h3 className="resultadobusca-titulo">

                  {produto.Descricao?.length > 36
                    ? `${produto.Descricao
                      .slice(0, 36)
                      .trim()
                      .replace(/\s+\S*$/, "")}...`
                    : produto.Descricao}

                </h3>

                {Number(produto.corrigepreco) === 1 && (
                  <span className="resultadobusca-peso-variavel">
                    Peso variável
                  </span>
                )}

                {usuario.login && (

                  <div className="resultadobusca-precos">

                    {ehCNPJ ? (

                      produto.valorunitario != null &&
                        Number(produto.valorunitario) <
                        Number(produto.precovenda) ? (

                        <>

                          <div className="resultadobusca-preco-antigo">
                            R$ {Number(produto.precovenda).toFixed(2)}
                          </div>

                          <div className="resultadobusca-preco-desconto">
                            R$ {Number(produto.valorunitario).toFixed(2)}
                          </div>

                        </>

                      ) : (

                        <div className="resultadobusca-preco-normal">
                          R$ {Number(produto.precovenda).toFixed(2)}
                        </div>

                      )

                    ) : (

                      <div className="resultadobusca-preco-normal">
                        R$ {Number(produto.precovenda).toFixed(2)}
                      </div>

                    )}

                  </div>

                )}

                <button
                  className="resultadobusca-botao"
                  onClick={() =>
                    navigate(`/cardproduto/${produto.CodItem}`)
                  }
                >
                  Ver produto
                </button>

              </div>

            ))

          )}

        </section>

      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}
